import { FeedbackType } from "../../../Constants";
import { IUIAsJson } from "../../Renderer";
import { IDs } from "../../UiConstants";
import { FormTemplateType } from "./FormTemplateType";

export function generate(): IUIAsJson {
	return undefined;
}

export const containerId: string = IDs.FeedbackPortalIdeaContainer;

/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export function onSelect(feedbackType: FeedbackType): void {
}

export const type: FormTemplateType = FormTemplateType.FeedbackPortalIdea;
